export default {
    isDoctorConsultConfigShow: state => state.doctorConsultConfigIsShow,

    isDoctorConsultTableShow: state => state.doctorConsultTableIsShow,
    isDoctorConsultFormShow: state => state.doctorConsultFormIsShow,

    isDoctorHolidayShow: state => state.doctorHolidayIsShow,
    isDoctorHolidayTableShow: state => state.doctorHolidayTableIsShow,
    isDoctorHolidayFormShow: state => state.doctorHolidayFormIsShow,

    getDoctorConsultActions: state => state.doctorConsultActions,
    getDoctorConsultFormActions: state => state.doctorConsultFormActions,
    getDoctorConsultRowActions: state => state.doctorConsultRowActions,
    getDoctorConsultHeaderFields: state => state.doctorConsultHeaderFields,
    getDoctorConsultSearchFields: state => state.doctorConsultSearchFields,
    getDataTableOptions: state => state.doctorConsultDataTableOptions,

    getDoctorHolidayActions: state => state.doctorHolidayActions,
    getDoctorHolidayFormActions: state => state.doctorHolidayFormActions,
    getDoctorHolidayRowActions: state => state.doctorHolidayRowActions,
    getDoctorHolidayHeaderFields: state => state.doctorHolidayHeaderFields

}
